import Icon from './Icon';

const Settings = ({ className }) => (
  <Icon name="settings" className={className} viewBox="0 0 20 20">
    <path d="M17.16,11a7.79,7.79,0,0,0,.07-1,7.79,7.79,0,0,0-.07-1l2.11-1.65a.5.5,0,0,0,.12-.64l-2-3.46a.5.5,0,0,0-.61-.22l-2.49,1a7.31,7.31,0,0,0-1.69-1L12.22.42A.49.49,0,0,0,11.73,0h-4a.49.49,0,0,0-.49.42L6.86,3.07a7.68,7.68,0,0,0-1.69,1l-2.49-1a.49.49,0,0,0-.61.22l-2,3.46a.49.49,0,0,0,.12.64L2.3,9a7.93,7.93,0,0,0-.07,1,7.93,7.93,0,0,0,.07,1L.19,12.63a.5.5,0,0,0-.12.64l2,3.46a.5.5,0,0,0,.61.22l2.49-1a7.31,7.31,0,0,0,1.69,1l.38,2.65a.49.49,0,0,0,.49.42h4a.49.49,0,0,0,.49-.42l.38-2.65a7.68,7.68,0,0,0,1.69-1l2.49,1a.49.49,0,0,0,.61-.22l2-3.46a.5.5,0,0,0-.12-.64ZM9.73,13.5a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,9.73,13.5Z" />
  </Icon>
);

// https://material.io/icons/#ic_settings (adapted)
export default Settings;
